import {useQuery} from "@tanstack/react-query";
import {readQnaDetailApi} from "../../../../api/support/qna";

interface ReadQnaDetailProps {
    id: string;
}

/**
 * QNA 상세조회 hook
 * @returns
 */
export const useReadQnaDetail = (props: ReadQnaDetailProps) => {
    const {id} = props;
    const res = useQuery({
        queryKey: ["readQnaDetailApi", id],
        queryFn: async (data) => await readQnaDetailApi(id),
        // staleTime: 6000 * 10,
        select: (res) => res?.result.qnaDetailRes,
        retry: false
    });

    return res;
};
